/**
 * Created by Administrador on 01/12/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .controller('parameterCtrl', parameterCtrl);

    parameterCtrl.$inject = ['linkService', 'tabParameters','parameters','parameterService'];

    function parameterCtrl(linkService, tabParameters,parameters,parameterService){
        var vm = this;
        vm.linkService = linkService;
        vm.tabs = tabParameters;

        vm.parameters = getParser(parameters);
        vm.old = angular.copy(vm.parameters);
        vm.buttonSave = true;

        vm.concat = function(index){
            vm.parameters[index].value = vm.parameters[index].value1+"|"+vm.parameters[index].value2;
        }

        vm.updateParameters = function(isValid, parameters, route) {
            if(isValid){
                parameters = validHAV(parameters);
                console.log('parameters', parameters);
                parameterService.updateParameters(parameters, route);
            }
        }

        function getParser(parameters){
            parameters = (parameters.data._embedded) ? parameters.data._embedded.parameters : [];
            for(var i=0; i<parameters.length; i++) {
                var parameter = parameters[i];
                var arrayValue = parameter.value.split('|');
                if (arrayValue.length > 1){
                    parameter.value1 = parseInt(arrayValue[0]);
                    parameter.value2 = parseInt(arrayValue[1]);
                }else{
                    if (parameter.type == "int") {
                        parameter.value = parseInt(parameter.value);
                    } else {
                        if (parameter.type == "bool") {
                            parameter.value = stringToBoolean(parameter.value);
                        }
                    }
                }
                parameter.id = vm.linkService.getLinkId(parameter._links.self.href)
            }
            return parameters;
        }

        function stringToBoolean(string){
            switch(string.toLowerCase().trim()){
                case "true": case "yes": case "1": return true;
                case "false": case "no": case "0": case null: return false;
                default: return Boolean(string);
            }
        }
        vm.change = function(){
            var flag = true;
            for(var i=0; i<vm.parameters.length; i++) {
                if(vm.parameters[i].value!=vm.old[i].value){
                    flag = false;
                    break;
                }
            }
            if(flag){
                vm.buttonSave = true;
            }else{
                vm.buttonSave = false;
            }
        }

        function validHAV(parameters) {
            for (var i=0; i<parameters.length; i++) {
                var parameter = parameters[i];
                if (parameter.code === 'HAV') {
                    if (parameter.value === null || parameter.value === undefined) {
                        parameter.value = 0
                    }
                }
            }
            return parameters;
        }
    }
})();
